import PropTypes from 'prop-types'
import { useFormContext, Controller } from 'react-hook-form'
import { MuiFileInput } from 'mui-file-input'
import './RHFFileField.css'

const RHFFileField = ({ name, placeholder, accept, helperText, ...other }) => {

    const { control } = useFormContext()
    let inputProps = {}
    if (accept) {
        inputProps = { accept }
    }

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <MuiFileInput
                    {...other}
                    fullWidth
                    name={field?.name}
                    onChange={field.onChange}
                    helperText={error ? error?.message : helperText}
                    value={field.value}
                    placeholder={placeholder}
                    inputProps={{ ...inputProps }}
                />
            )
            }
        />
    )
}
RHFFileField.propTypes = {
    name: PropTypes.string,
    placeholder: PropTypes.string,
    accept: PropTypes.string,
    helperText: PropTypes.node,
}
export default RHFFileField
